// https://vuetmp.vuejs.org/en/mutations.html

export default {
  loadProductGroupsTableSuccess: ({ table }, payload) => {
    table.pagination.totalItems = payload.recordsTotal;
    table.data = payload.data;
  },
  setTablePagination({ table }, payload) {
    table.pagination = payload;
  },
  loadSpecifiedGroupSuccess: (state, payload) => {
    state.specifiedGroup = payload;
    state.specifiedGroup.loading = false;
    const keys = Object.keys(payload.customFields);

    const newCustomFields = keys.reduce((acc, next) => {
      acc[next] = {
        ...payload.customFields[next],
        isVisible:
          payload.customFields[next].title || payload.customFields[next].placeholder ? true : false,
      };
      return acc;
    }, {});
    state.specifiedGroup.customFields = newCustomFields;
  },
  loadShopProductsSuccess: (state, payload) => {
    state.products.data = payload;
    state.products.loading = false;
  },
  loadAllGroupsTableSuccess: ({ allGroupsTable }, payload) => {
    allGroupsTable.data = payload.data;
    allGroupsTable.loading = false;
    allGroupsTable.pagination.totalItems = payload.recordsTotal;
  },
  setAllGroupsTableLoading: ({ allGroupsTable }, payload) => {
    allGroupsTable.loading = payload;
  },
  setPagination: ({ allGroupsTable }, payload) => {
    allGroupsTable.pagination = payload;
  },
};
